import React from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import ContactFormType from '../types/ContactFormType';
import Button from './UI/Button';
import style from '../pages/Contact.module.css';

function ContactForm({
  onSubmit,
}: {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: ContactFormType) => void;
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ContactFormType>();
  const intl = useIntl();

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={style.contactForm}
      data-cy="form"
      data-testid="form"
    >
      <div className="row">
        <div className="col-12 col-md-6">
          <input
            type="text"
            {...register('name', {
              required: intl.formatMessage({ id: 'contact.field-mantatory' }),
              minLength: {
                value: 5,
                message: intl.formatMessage(
                  { id: 'contact.too-short' },
                  {
                    field: intl.formatMessage({ id: 'contact.name' }),
                    number: 5,
                  },
                ),
              },
              maxLength: {
                value: 150,
                message: intl.formatMessage(
                  { id: 'contact.too-long' },
                  {
                    field: intl.formatMessage({ id: 'contact.name' }),
                    number: 150,
                  },
                ),
              },
            })}
            placeholder={intl.formatMessage({ id: 'contact.your-name' })}
            minLength={5}
            maxLength={150}
            className={cx({ [style.invalidField]: errors.name })}
            required
          />
          {errors.name && (
            <span className={style.invalidFieldMessage} role="alert">
              {errors.name.message}
            </span>
          )}
        </div>
        <div className="col-12 col-md-6">
          <input
            type="email"
            {...register('email', {
              required: intl.formatMessage({ id: 'contact.field-mantatory' }),
              minLength: {
                value: 10,
                message: intl.formatMessage(
                  { id: 'contact.too-short' },
                  { field: 'Email', number: 10 },
                ),
              },
              maxLength: {
                value: 200,
                message: intl.formatMessage(
                  { id: 'contact.too-long' },
                  { field: 'Email', number: 200 },
                ),
              },
              pattern: {
                value:
                  // eslint-disable-next-line no-useless-escape
                  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                message: intl.formatMessage({ id: 'contact.invalid-email' }),
              },
            })}
            placeholder={intl.formatMessage({ id: 'contact.your-email' })}
            minLength={10}
            maxLength={200}
            className={cx({ [style.invalidField]: errors.email })}
            required
          />
          {errors.email && (
            <span className={style.invalidFieldMessage} role="alert">
              {errors.email.message}
            </span>
          )}
        </div>
        <div className="col-12 col-md-12">
          <input
            {...register('subject', {
              required: intl.formatMessage({ id: 'contact.field-mantatory' }),
              minLength: {
                value: 10,
                message: intl.formatMessage(
                  { id: 'contact.too-short' },
                  {
                    field: intl.formatMessage({ id: 'contact.subject' }),
                    number: 10,
                  },
                ),
              },
              maxLength: {
                value: 200,
                message: intl.formatMessage(
                  { id: 'contact.too-long' },
                  {
                    field: intl.formatMessage({ id: 'contact.subject' }),
                    number: 200,
                  },
                ),
              },
            })}
            type="text"
            placeholder={intl.formatMessage({ id: 'contact.email-subject' })}
            minLength={10}
            maxLength={200}
            className={cx({ [style.invalidField]: errors.subject })}
            required
          />
          {errors.subject && (
            <span className={style.invalidFieldMessage} role="alert">
              {errors.subject.message}
            </span>
          )}
        </div>
        <div className="col-12 col-md-12">
          <input
            type="text"
            {...register('age')}
            placeholder={intl.formatMessage({ id: 'contact.age' })}
            className={style.pasla}
          />
        </div>
        <div className="col-12">
          <textarea
            {...register('content', {
              required: intl.formatMessage({ id: 'contact.field-mantatory' }),
              minLength: {
                value: 100,
                message: intl.formatMessage(
                  { id: 'contact.too-short' },
                  { field: 'Message', number: 100 },
                ),
              },
              maxLength: {
                value: 500,
                message: intl.formatMessage(
                  { id: 'contact.too-long' },
                  { field: 'Message', number: 500 },
                ),
              },
            })}
            placeholder={intl.formatMessage({ id: 'contact.message' })}
            minLength={100}
            maxLength={500}
            className={cx({ [style.invalidField]: errors.content })}
            required
          />
          {errors.content && (
            <span className={style.invalidFieldMessage} role="alert">
              {errors.content.message}
            </span>
          )}
          <Button buttonType="submit" icon="btnSend">
            <FormattedMessage id="contact.send" tagName="span" />
          </Button>
        </div>
      </div>
    </form>
  );
}

export default ContactForm;
